import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import Table from '../../widgets/tables/Table';
import WaitDialog from '../../widgets/WaitDialog';
import SelectPdfDatesWidget from '../../widgets/SelectPdfDatesWidget';
import { NineCellLoading } from 'react-loadingg';
import GetCorsi from '../../services/getCorsi';
import checkUtente from "../../services/checkUtente";
import getInsegnanti from '../../services/getInsegnanti';
import getMaterie from '../../services/getMaterie';
import getLezioni from "../../services/getLezioni";
import AdWidget from "../../widgets/AdWidget";
import translateString from "../../utils/Locales";

let t = translateString;

export default class TeacherCorsi extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      waitDialogVisible: false,
      selectPdfDatesVisible: false,
      mailCompaniesList: []
    }

    this.grid = 2;

    this.pdfElements = [];

    this.corsi = [];

    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });
    this.dbPath = cookies.get('db_path', { path: '/' });
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {

    };

  }

  async reload() {

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.utente = await checkUtente(username, token, username);
    this.corsi = await GetCorsi(username, token);
    this.insegnanti = await getInsegnanti(username, token);
    this.currUtente = this.insegnanti.filter((insegnante) => insegnante.id === this.utente[0].user_id)[0];

    this.materie = await getMaterie(username, token);
    this.materie = this.materie.filter((materia) => materia.id_insegnante === this.currUtente.id);
    var mat_str = '';
    this.materie.forEach((materia) => mat_str += materia.id + ';');
    this.currUtente.materie = mat_str;
   
    this.lezioni = await getLezioni(username, token);
    this.lezioni = this.lezioni.filter((lezione) => this.currUtente.materie.indexOf(lezione.id_materia+';') != -1);

    var corsi_str = '';
    this.lezioni.forEach((lezione) => {
        if (corsi_str.indexOf(lezione.id_corso+';') == -1) {
          corsi_str += lezione.id_corso + ';';
        }
    });

    this.corsi = this.corsi.filter((corso) => corsi_str.indexOf(corso.id+';') != -1);
    
    this.setState({ });

  }

  async componentDidMount(){
    await this.reload();
  }


  render () {

    const cookies = new Cookies();

    var headCells = [
      { id: 'name', numeric: false, disablePadding: true, label: t('nome') },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    this.searchCols = ['name'];
    
    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <div id={Math.random()}>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: () => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('tuoi_corsi')} />

        <Table headCells={headCells} searchCols={this.searchCols} rows={this.corsi} mail={false} phone={false} calendar={true} pdf={false}
          onEventClick={(row) => {
            cookies.set('currentCourse', row, { path: '/' });
            window.location.href =  '/' + this.dbPath + '/#/app/esamiCorso';
        }}

          onCalendarClick={(id) => {
            cookies.set('currentCourse', id, { path: '/' });
            window.location.href= '/' + this.dbPath + '/#/app/schedule';
          }}
        />

        {this.elementPdf ? this.elementPdf : null}

        { this.state.selectPdfDatesVisible && (
            <SelectPdfDatesWidget show={this.state.selectPdfDatesVisible} daDate={this.state.startDate} toDate={this.state.endDate} key={Math.random()} onCancel={ () => this.setState({ selectPdfDatesVisible: false }) } onOkClicked={(dateFrom, dateTo) => {
              const cookies = new Cookies();
              cookies.set('currentCorso', this.state.pdfElem, { path: '/' });
              cookies.set('dateFrom', dateFrom, { path: '/' });
              cookies.set('dateTo', dateTo, { path: '/' });
              window.location.href=  '/' + this.dbPath + '/#/app/pdfCorsoPage';
            }}/>
        )}

        <AdWidget bottomWidget={true} />
        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </div>
    );
  }
}

